export enum EnvType {
  DEV = 'development',
  PROD = 'production',
  LOCAL = 'local',
}
